export default {
  packages: [],
  selection: null,
  get total () {
    return this.selection.categories
      .filter(category => category.active && category.name !== 'NETWERKKOSTEN')
      .reduce((total, category) => {
        return category.products.reduce((productTotal, product) => {
          if (
            (product.active || product.active === 1) &&
            product.product_interval !== 'EENMALIG' &&
            category.name !== 'INCENTIVE'
          ) {
            productTotal += parseFloat(product.product_price)
          }

          return productTotal
        }, total)
      }, 0)
  },
  get incentivePrice () {
    let incentivePrice

    switch (this.selection.incentive_type) {
      case 'price':
        incentivePrice = this.selection.incentive_value
        break
      case 'procent':
        incentivePrice = this.selection.price * (this.selection.incentive_value / 100)
        break
      case 'package':
        incentivePrice = this.selection.price
        break
    }

    incentivePrice += this.selection.categories
      .filter(category => category.active)
      .reduce((total, category) => {
        return category.products.reduce((productTotal, product) => {
          if (
            (product.active || product.active === 1) &&
            product.product_interval !== 'EENMALIG'
          ) {
            productTotal += parseFloat(product.extra_price_base)
          }

          return productTotal
        }, total)
      }, 0)

    return incentivePrice
  },
  get oneTimePrice () {
    return this.selection.categories
      .filter(category => category.active && category.name !== 'NETWERKKOSTEN')
      .reduce((total, category) => {
        return category.products.reduce((productTotal, product) => {
          if (
            (product.active || product.active === 1) &&
            product.product_interval === 'EENMALIG'
          ) {
            productTotal += parseFloat(product.product_price)
          }

          return productTotal
        }, total)
      }, 0)
  },
  get groupedCategories () {
    const groupedCategories = {}
    this.selection.categories.forEach(category => {
      // if (
      //   category.parent === 'INCENTIVE' &&
      //   this.selection.incentive_type !== 'package'
      // ) {
      //   return
      // }

      if (category.name === category.parent) {
        groupedCategories[category.name] = {
          name: category.name,
          title: category.title,
          id: category.id,
          active: category.active,
          children: [category],
          selector: category.selector,
          required: category.required ?? false
        }
      } else {
        groupedCategories[category.parent].children.push(category)
      }
    })

    return groupedCategories
  },
  Zoekgegevens: {
    street: '',
    houseno: '',
    houseno_ext: '',
    zipcode: '',
    room: '',
    city: '',
    network: '',
    cust_type: '',
    netwerkstatus: '',
    netwerk_code: '',
    netwerk_gebiedscode: ''
  },
  Klantengegevens: {
    Persoonsgegevens: {
      Geslacht: '',
      Voorletters: '',
      Tussenvoegsel: '',
      Achternaam: '',
      Geboortedatum: ''
    },
    Adresgegevens: {
      Adres: '',
      Huisnr: '',
      Huisnr_toev: '',
      Postcode: '',
      Plaats: ''
    },
    Contactgegevens: {
      MobielTelefoonnummer: '',
      VastTelefoonnummer: '',
      Emailadres: '',
      PLINQEmailadres: ''
    },
    Betaalgegevens: {
      Rekeningnummer: '',
      NaamRekeninghouder: '',
      WoonplaatsRekeninghouder: ''
    },
    Overig: {
      Opmerking: '',
      AlgemeneVoorwaarden: false
    }
  }
}
